import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _ChannelGetter = Getter.of();
export const _ChannelResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _ChannelResponse2Channel = _Response2ResponseData();
export const _Channel2Data = Fold.compose(_ChannelGetter, Res._Response());
export const _Channel2Attributes = Fold.compose(_Channel2Data, Lens.prop("attributes"));
export const _ChannelAttributes2AlternateId = Fold.compose(_Channel2Attributes, Lens.prop("alternateId"));
export const _ChannelAttributes2CustomAttributes = Fold.compose(_Channel2Attributes, Lens.prop("customAttributes"));
export const _ChannelAttributes2Description = Fold.compose(_Channel2Attributes, Lens.prop("description"));
export const _ChannelAttributes2GeoRestrictions = Fold.compose(_Channel2Attributes, Lens.prop("geoRestrictions"));
export const _ChannelAttributes2HasLiveStream = Fold.compose(_Channel2Attributes, Lens.prop("hasLiveStream"));
export const _ChannelAttributes2LongDescription = Fold.compose(_Channel2Attributes, Lens.prop("longDescription"));
export const _ChannelAttributes2Identifiers = Fold.compose(_Channel2Attributes, Lens.prop("identifiers"));
export const _ChannelAttributes2ContentDescriptors = Fold.compose(_Channel2Attributes, Lens.prop("contentDescriptors"));
export const _ChannelAttributes2ContentRatings = Fold.compose(_Channel2Attributes, Lens.prop("contentRatings"));
export const _ChannelAttributes2ChannelCode = Fold.compose(_Channel2Attributes, Lens.prop("channelCode"));
export const _ChannelAttributes2Name = Fold.compose(_Channel2Attributes, Lens.prop("name"));
export const _ChannelAttributes2Packages = Fold.compose(_Channel2Attributes, Lens.prop("packages"));
export const _ChannelAttributes2PlaybackAllowed = Fold.compose(_Channel2Attributes, Lens.prop("playbackAllowed"));
export const _Channel2ContentPackages = Fold.compose(_ChannelGetter, Res._Rel("contentPackages"), Res._ForEach());
export const _Channel2Images = Fold.compose(_ChannelGetter, Res._Rel("images"), Res._ForEach());
export const _Channel2Routes = Fold.compose(_ChannelGetter, Res._Rel("routes"), Res._ForEach());
export const _Channel2TxGenres = Fold.compose(_ChannelGetter, Res._Rel("txGenres"), Res._ForEach());

